import { Link } from "@tanstack/react-router";
import { AlertCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { Component, type ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface Props {
	children: ReactNode;
	fallback?: ReactNode;
}

interface State {
	hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
	state: State = { hasError: false };

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	handleRetry = () => {
		this.setState({ hasError: false });
	};

	render() {
		if (!this.state.hasError) {
			return this.props.children;
		}

		if (!this.props.fallback) {
			return (
				<Card className="border-destructive/40 bg-destructive/5">
					<CardContent className="p-6 sm:p-8">
						<div className="flex flex-col items-center gap-4 text-center">
							<div className="flex size-12 items-center justify-center rounded-full bg-destructive/10">
								<AlertCircle className="size-6 text-destructive" />
							</div>
							<div className="space-y-2">
								<h3 className="text-lg font-semibold">Algo deu errado</h3>
								<p className="max-w-md text-sm text-muted-foreground">
									Não foi possível carregar este conteúdo.
								</p>
							</div>
							<div className="flex flex-wrap items-center justify-center gap-2">
								<Button variant="outline" onClick={this.handleRetry} className="gap-2">
									<RefreshCw className="size-4" />
									Tentar de novo
								</Button>
								<Button asChild variant="ghost" onClick={this.handleRetry} className="gap-2">
									<Link to="/">
										<ArrowLeft className="size-4" />
										Voltar
									</Link>
								</Button>
							</div>
						</div>
					</CardContent>
				</Card>
			);
		}

		return this.props.fallback;
	}
}
